import React from 'react';
import styles from '../styles/components/ActionsDropdown.module.css';

interface Action {
  text: string;
  icon?: string;
  onCompletion: () => void;
}
interface DropdownProps {
  actions: Action[];
}

function getActions(actions: Action[]) {
  return actions.map((action, index) => (
    <div
      className={styles.actionWrapper}
      key={index}
      onClick={action.onCompletion}
    >
      {action.icon && (
        <i className={`material-icons ${styles.actionIcon}`}>{action.icon}</i>
      )}
      <span className={styles.actionText}>{action.text}</span>
    </div>
  ));
}

const ActionsDropdown: React.FC<DropdownProps> = props => {
  const [isVisible, setIsVisible] = React.useState(false);
  const showDropdownMenu = (event: React.MouseEvent) => {
    if (!isVisible) {
      event.preventDefault();
      setIsVisible(true);
      document.addEventListener('click', hideDropdownMenu);
    }
  };
  const hideDropdownMenu = () => {
    document.removeEventListener('click', hideDropdownMenu);
    setIsVisible(false);
  };

  return (
    <div className={styles.dropdownWrapper} onClick={showDropdownMenu}>
      <i className={`material-icons ${styles.dropdownIcon}`}>more_horiz</i>
      {isVisible && (
        <div className={styles.actionsContainer}>
          {getActions(props.actions)}
        </div>
      )}
    </div>
  );
};
export default ActionsDropdown;
